// extracted by mini-css-extract-plugin
module.exports = {"container-A":"termsofuse_container-A__3HVsP","container":"termsofuse_container__1OBUm","title":"termsofuse_title__oiH7R","content":"termsofuse_content__258Ai"};